import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicyPage: React.FC = () => {
  const lastUpdated = "January 1, 2024";
  const companyName = "SaaS Starter Inc.";
  const dpoEmail = "privacy@example.com";

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 max-w-3xl">
      <header className="mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground mb-3">Cookie Policy</h1>
        <p className="text-sm text-muted-foreground">Last Updated: {lastUpdated}</p>
      </header>

      <section className="space-y-6 text-foreground/90 leading-relaxed">
        <p>
          This Cookie Policy explains how {companyName} uses cookies and similar technologies.
        </p>
        <p>
            This is a generic cookie policy template. Replace with your actual policy.
        </p>
        <h2 className="text-2xl font-semibold pt-4 border-b pb-2">1. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device to help us improve your experience.
        </p>
        
        <h2 className="text-2xl font-semibold pt-4 border-b pb-2">Contact Us</h2>
        <p>
          If you have questions, contact us at <a href={`mailto:${dpoEmail}`} className="text-primary hover:underline">{dpoEmail}</a>.
        </p>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
